export default "__VITE_ASSET__17ebe63a__"